import { CondensedMealCard } from 'src/componentsV2/MenuMealCard/CondensedMealCard/CondensedMealCard'
import './FreePremiumMealsBottomSheetModal.scss'
import { CuiBottomSheet, CuiButton } from 'front-lib'
import { isAddOn } from 'src/modules/MyPlan/utils'

const IMG_URL_SOURCE = process.env.REACT_APP_IMG_URL_SOURCE

export const FreePremiumMealsBottomSheetModal = ({
  isOpen,
  onRequestClose,
  title,
  meals,
  onAddItem,
  onClickMeal,
  onRemoveItem,
  onDiscardChangesBtnClicked,
  freeMealsCompleted,
  subtitle,
  cancelText,
  confirmText,
  onConfirm
}) => {
  return (
    <CuiBottomSheet
      className="free-premium-meals-bottom-sheet-modal"
      isOpen={isOpen}>
      <CuiBottomSheet.Header onRequestClose={onRequestClose}>
        <div className="free-premium-meals-modal-mobile-header">
          <span className="free-premium-meals-modal-mobile-title">{title}</span>
          <span className="free-premium-meals-modal-mobile-subtitle">
            {subtitle}
          </span>
        </div>
      </CuiBottomSheet.Header>
      <CuiBottomSheet.Body className="modal-sheet-body">
        <div className="meals-container">
          {meals.map(meal => (
            <div key={meal.id}>
              <CondensedMealCard
                key={meal.id}
                meal={{
                  ...meal,
                  magentoId: meal.magento_id,
                  full_path_meal_image: meal.imageUrl,
                  full_path_chef_image: `${IMG_URL_SOURCE}${meal.bannerpic}`,
                  protein_type: meal.meat_type,
                  short_description: meal.short_description || '',
                  premium_special: meal.premium_special || null,
                  secondary_image:
                    (meal.media && meal.media.secondaryImage) || null
                }}
                quantity={meal.quantity || 0}
                onAddItem={onAddItem}
                onRemoveItem={onRemoveItem}
                onMealClick={() => onClickMeal(meal)}
                isEditable
                isExtra={isAddOn(meal)}
                noExtraMealPlanIsCompleted={false}
                planIsCompleted={false}
                onLikeMeal={() => {}}
                onUnLikeMeal={() => {}}
                isLoading={false}
                isLikeMarked={false}
              />
            </div>
          ))}
        </div>
        <div className="modal-sheet-footer">
          <CuiButton
            onClick={onDiscardChangesBtnClicked}
            size="large"
            fill="outline"
            color="light">
            {cancelText}
          </CuiButton>
          <CuiButton
            onClick={onConfirm}
            size="large"
            fill="outline"
            color="dark"
            disabled={!freeMealsCompleted}>
            {confirmText}
          </CuiButton>
        </div>
      </CuiBottomSheet.Body>
    </CuiBottomSheet>
  )
}
